import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import { usePageMeta } from "@/hooks/usePageMeta";
import { heroSlides } from "@/mocks/hero";
import type { HeroSlide } from "@/types/media";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import QuickEntry from "@/pages/home/components/QuickEntry";
import HotMedia from "@/pages/home/components/HotMedia";
import NewsFlash from "@/pages/home/components/NewsFlash";
import SiteIntro from "@/pages/home/components/SiteIntro";

export default function Home() {
  usePageMeta({
    title: "四虎网站 - 高清电影电视剧资源汇聚平台",
    description:
      "四虎网站集合海量高清电影、电视剧资源，提供最新影视资讯和影片介绍，满足用户多样影视浏览需求。",
    keywords: "四虎网站,影视资源,高清电影,电视剧,影视资讯,电影推荐,影视平台",
  });

  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <SiteHeader />
      <main className="flex-1 w-full">
        <HeroCarousel slides={heroSlides as HeroSlide[]} />
        <QuickEntry />
        <HotMedia />
        <NewsFlash />
        <SiteIntro />
      </main>
      <SiteFooter />
    </div>
  );
}